// extracted by mini-css-extract-plugin
export var carrierIcon = "_ym-0";
export var carrierLogo = "_ym-1";
export var detailsSection = "_ym-2";